import React from "react";

const AboutUsPage = () => {
  const historyData = [
    {
      year: "2021 - 22",
      items: [
        "Enhanced customer reach with new office setups in Bangalore & Pune.",
        "Proximity Calculator Feature added to locate the social infrastructure near the property.",
        "Featured in Hindustan Times & Mid-Day for notable work in the real estate industry.",
        "Scaled up the Housing.in Home Loan Distribution Services.",
      ],
    },
  ];

  const coreValues = [
    "Consistency",
    "Honesty",
    "Trustworthiness",
    "Accountability",
    "Respect Everyone",
    "Innovation",
    "Team Work",
    "Quality Service",
    "Integrity",
  ];

  return (
    <div className="p-6 bg-gray-50">
      {/* Header Section */}
      <header className="text-center py-6">
        <h1 className="text-3xl font-bold text-gray-800">
          About <span className="text-blue-600">Housing.in</span>
        </h1>
        <p className="text-gray-600 mt-2">
          Established in 2013, we are committed to solving the toughest challenges of the Indian real estate industry.
        </p>
        <p className="text-gray-600 mt-2">
          Our secure, technology-driven platform empowers property buyers with comprehensive solutions.
        </p>
      </header>

      {/* About Section */}
      <section className="my-8">
        <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
          <p className="text-gray-600">
            Today, Housing.in immensely empowers property buyers with end-to-end real estate services. Our qualified property experts, personalized services, and advanced digital tools allow buyers to make informed decisions & quickly buy, sell, & rent properties online.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
            <div className="flex items-center bg-gray-50 shadow-md rounded-lg p-4">
              <img
                src="/expert.png"
                alt="Served Buyers"
                className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
              />
              <p className="text-gray-700">Served 2,50,000+ buyers</p>
            </div>
            <div className="flex items-center bg-gray-50 shadow-md rounded-lg p-4">
              <img
                src="/legal.png"
                alt="PAN India Presence"
                className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
              />
              <p className="text-gray-700">
                PAN India presence: Offices in Mumbai, Navi Mumbai, Thane, Pune, and Bangalore
              </p>
            </div>
            <div className="flex items-center bg-gray-50 shadow-md rounded-lg p-4">
              <img
                src="/pricenegotiation.png"
                alt="Customer Assistance"
                className="w-16 h-16 rounded-full border-2 border-blue-500 mr-4"
              />
              <p className="text-gray-700">End-to-End Customer Assistance</p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="my-8">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Our History
        </h2>
        {historyData.map((history, index) => (
          <div
            key={index}
            className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300 mb-6"
          >
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              {history.year}
            </h3>
            <ul className="list-disc list-inside text-gray-600">
              {history.items.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      {/* Vision, Mission, and Objective Section */}
      <section className="my-8">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Objective, Vision, and Mission
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h3 className="text-xl font-bold text-blue-600">Vision</h3>
            <p className="text-gray-600 mt-4">
              To Build “The Trustworthy Global Real Estate Community.”
            </p>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h3 className="text-xl font-bold text-blue-600">Mission</h3>
            <p className="text-gray-600 mt-4">
              “To Empower Smooth Transition of Real Estate Needs.”
            </p>
          </div>
          <div className="bg-white shadow-lg rounded-lg p-6 border-l-4 border-blue-500 hover:shadow-xl transition duration-300">
            <h3 className="text-xl font-bold text-blue-600">Objective</h3>
            <p className="text-gray-600 mt-4">
              “To be an online trustworthy platform that can help property buyers buy property online and in ‘reduced property search cycle time’ with excellent customer service.”
            </p>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="my-8">
        <h2 className="text-2xl font-bold text-gray-800 text-center mb-6">
          Our Values
        </h2>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
          {coreValues.map((value, index) => (
            <div
              key={index}
              className="bg-white shadow-lg rounded-lg p-6 text-center border-l-4 border-blue-500 hover:shadow-xl transition duration-300"
            >
              <p className="text-gray-800 font-semibold">{value}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutUsPage;
